import Vue from "vue";

import HeaderMobile from "@/header-mobile/header-mobile";
import SeasonManager from "@/seasonManager/seasonManager";
import GreenThing from "@//greenThing/greenThingOnGallery";
import AppInitializer from "@/appInitializer/appInitializer";
import BookingService from "@/services/BookingService";
import CatalogService from "@/services/CatalogService";
import FeedbackService from "@/services/FeedbackService";
import SearchEngineService from "@/services/SearchEngineService";
import ModuleLoader from "@/moduleLoader/moduleLoader";
import ScreenSizeManager from "@/screenSizeManager/screenSizeManager";
import SmoothScrollController from "@/smoothScrollController/smoothScrollController";
import Navbar from "@/navbar/navbar";

import starter_collapsibles from "@/main/starters/starter_collapsibles";
import starter_textPopups from "@/main/starters/starter_textPopups";
import starter_textShowMoreLess from "@/main/starters/starter_textShowMoreLess";
import starter_scrollEvents from "@/main/starters/starter_scrollEvents";
import starter_gallery from "@/main/starters/starter_gallery";
import starter_map from "@/main/starters/starter_map";
import starter_reviews from "@/main/starters/starter_reviews";
import starter_merchandising from "@/main/starters/starter_merchandising";
import starter_seasonSwitcher from "@/main/starters/starter_seasonSwitcher";
import starter_planning from "@/main/starters/starter_planning";
import starter_clubAdvantages from "@/main/starters/starter_clubAdvantages";

// import css
import "@/css/anchors.css";
import "@/css/basePopup.css";
import "@/css/bootstrap-light.css";
import "@/css/datepicker.css";
import "@/css/design-system--light.css";
import "@/css/desktopGallery.css";
import "@/css/faq.css";
import "@/css/general.css";
import "@/css/greenThing.css";
import "@/css/hoverEffects.css";
import "@/css/iconsSize.css";
import "@/css/loadingGif.css";
import "@/css/merchandising.css";
import "@/css/mobileSlider.css";
import "@/css/navbar.css";
import "@/css/overlay.css";
import "@/css/seasonSwitcher.css";
import "@/css/stationDescription.css";
import "@/css/textPopup.css";
import "@/css/textShowMoreLess.css";
// import "@/css/buttons.css";
import "@/css/colors.css";
// import "@/css/footer.css";
// import "@/css/header.css";
import "@/css/documentTop.css";
import "@/css/select-controls.css";
import "@/css/fonts.css";
import "@/css/reviews.css";
import "@/css/borders.css";
import "@/css/breadcrumb.css";
// import "@/css/new-design-system.css";

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV === "development" ? true : false;

(async () => {
	Array.from(document.querySelectorAll("[data-none]")).forEach((el) => {
		el.style.display = "none";
	});
})();

window.seasonManager = new SeasonManager();
window.seasonManager.init();

window.headerMobile = new HeaderMobile();
window.headerMobile.init();

window.navbar = new Navbar(document.querySelector("section#tf-navbar"));
window.navbar.init();

window.greenThing = new GreenThing();
window.greenThing.init();

window.bookingService = new BookingService();
window.catalogService = new CatalogService();
window.feedbackService = new FeedbackService();
window.requestCounter = 0;
window.searchEngineService = new SearchEngineService();

window.appInitializer = new AppInitializer();

window.moduleLoader = new ModuleLoader();

window.screenSizeManager = new ScreenSizeManager();
window.screenSizeManager.init();

window.smoothScrollController = new SmoothScrollController();
window.smoothScrollController.init();
(async () => {
	await starter_collapsibles();
})();

(async () => {
	await starter_textPopups();
})();

(async () => {
	await starter_textShowMoreLess();
})();

(async () => {
	await starter_scrollEvents();
})();

(async () => {
	await starter_gallery();
})();

(async () => {
	await starter_map();
})();

(async () => {
	await starter_reviews();
})();

(async () => {
	await starter_merchandising();
})();

(async () => {
	await starter_seasonSwitcher();
})();

(async () => {
	await starter_planning();
})();

(async () => {
	await starter_clubAdvantages();
})();

(async () => {
	// if refreshed page and it started loading far from top - instantiate all apps
	if (window.scrollY > 500) {
		// console.log(`far from top - initializing all apps`)
		window.appInitializer.initAll();
	}
})();
